import { GENDER, USER_TYPE } from "types";

export enum STAFF_STATUS {
	ENABLE = "enable",
	DISABLE = "disable",
}

export interface StaffRole {
	id: number;
	name: string;
}

export interface Staff {
	id: number;
	username: string;
	fullName: string | null;
	avatar: string | null;
	phoneNumber: string | null;
	email: string | null;
	idCard: string | null;
	gender: GENDER;
	birthday: string | null;
	status: STAFF_STATUS;
	userType: USER_TYPE;
	address: string | null;
	createdAt?: string;
	updatedAt?: string;
	roles?: StaffRole[] | number[];
	permissions?: string[];
}

export interface StaffQueryParams {
	fullName?: string | null;
	phoneNumber?: string | null;
	email?: string | null;
	skip: number;
	take: number;
	status?: string | null;
	role?: number | null;
}

export interface DataChangePass {
	currentPassword: string;
	newPassword: string;
	passwordConfirmation: string;
}
